module.exports = __webpack_public_path__ + "img/login-top-img.43807e3.png";